var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg130Surprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256 s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c46.812,0,92.616-12.757,132.462-36.893 c9.447-5.722,12.467-18.021,6.744-27.468c-5.724-9.449-18.023-12.468-27.469-6.745C334.143,461.244,295.504,472,256,472 c-119.103,0-216-96.897-216-216S136.897,40,256,40s216,96.897,216,216c0,42.589-12.665,84.044-36.626,119.885 c-6.139,9.182-3.672,21.603,5.51,27.742c9.183,6.14,21.604,3.671,27.742-5.511C497.002,355.674,512,306.531,512,256 C512,187.62,485.371,123.333,437.02,74.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,201c0-19.071-3.87-37.315-10.898-51.371C198.005,131.435,183.753,121,168,121s-30.005,10.435-39.102,28.629 C121.87,163.685,118,181.929,118,201c0,11.046,8.954,20,20,20s20-8.954,20-20c0-20.749,6.112-34.262,10-38.831 c3.888,4.569,10,18.082,10,38.831c0,11.046,8.954,20,20,20S218,212.046,218,201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,201c0-20.749,6.112-34.262,10-38.831c3.888,4.569,10,18.082,10,38.831c0,11.046,8.954,20,20,20 c11.046,0,20-8.954,20-20c0-19.071-3.87-37.315-10.898-51.371C375.005,131.435,360.753,121,345,121s-30.005,10.435-39.102,28.629 C298.87,163.685,295,181.929,295,201c0,11.046,8.954,20,20,20C326.046,221,335,212.046,335,201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.15,376.902C221.127,387.283,238.12,393,256,393s34.873-5.717,47.85-16.098C317.927,365.64,326,349.638,326,333 s-8.073-32.64-22.15-43.902C290.873,278.717,273.88,273,256,273s-34.873,5.717-47.85,16.098C194.073,300.36,186,316.362,186,333 S194.073,365.64,208.15,376.902z M256,313c15.981,0,30,9.346,30,20s-14.019,20-30,20c-15.981,0-30-9.346-30-20 S240.019,313,256,313z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg130Surprise);
export default __webpack_public_path__ + "static/media/130-surprise.f348d772c7d39e25cf3bb3009e62d4cd.svg";
export { ForwardRef as ReactComponent };